import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './Screens/LandingPage';
import Home from './Screens/Home';
import ProductPage from './Screens/ProductPage';
import Technologies from './Screens/Technologies';
import AboutUs from './Screens/AboutUs';
import ContactUs from './Screens/ContactUs';
import Footer from './Footer';

function App() {
  return (
    <Router>
      <LandingPage />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/technologies" element={<Technologies />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
